import {
  Component,
  Input,
  inject,
  ChangeDetectionStrategy
} from '@angular/core';
import { Router } from '@angular/router';
import Session from 'store-management';
import { TUser } from '../../types';
import { UserRoles } from '../../types/enums';
import { hasRole } from '../../utils/string';
import { BreadCrumbs } from './breadcrumbs.types';

@Component({
  selector: 'cohrex-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BreadcrumbsComponent {
  router: Router = inject(Router);
  private _crumbs?: BreadCrumbs[];
  @Input()
  set crumbs(value: BreadCrumbs[] | undefined) {
    this._crumbs = value;
  }
  get crumbs(): BreadCrumbs[] | undefined {
    return this._crumbs;
  }

  session!: Session;
  user?: TUser;

  constructor() {
    this.session = new Session();
  }

  goToHome(): void {
    const user = this.session.get('user');
    const isTestTaker = hasRole(user.roles, UserRoles.TestTaker);
    this.router.navigate([isTestTaker ? '/tests' : '/admin']);
  }

  handleNavigate(linkTo: string): void {
    this.router.navigate([linkTo]);
  }
}
